import React, { FC } from 'react'
import { SvgIcon } from 'components/icon'

import './Spinner.scss'

interface Props {
  width?: number
  height?: number
}

export const Spinner: FC<Props> = ({ width, height }) => (
  <div
    className="ui-spinner"
    style={{
      width,
      height,
    }}>
    <SvgIcon name="loader" width={width} height={height} />
  </div>
)
